

import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import SectionPortfolio from "../../components/sections/portfolio";
import CardPortfolio from "../../components/card/card_portfolio";
import CardPortfolioService from "../../components/card/card_portfolio_service";
import {useParams} from "react-router";
import {Link} from "react-router-dom";
import PortfolioApi from "../../components/api/portfolio_api";
import Helmet from "react-helmet";
import axios from "axios";
import {Oval} from "react-loader-spinner";
import LoaderComponent from "../../components/basic/loader";

function AppServicesPage(props) {

    // let {slug} = useParams();

    const { t, i18n } = useTranslation()

    const STORAGE_URL = 'https://storage.lukyanchuk.com';

    const API_URL = 'https://api.lukyanchuk.com/api/v1/public/data/services?slug=';// + slug;

    const [data, setData] = useState([]);

    // useEffect(() => {
    //
    //     axios.get(API_URL, {}).then( response => {
    //
    //         setData(response.data.data)
    //
    //     }).catch(e => console.log(e.message))
    //
    // }, [])
    //
    // if(data === null){
    //     return <LoaderComponent
    //         text={slug}
    //         smallText={'Service'}
    //     />;
    // }

    const stack = [
        'Dart', 'Flutter', 'Firebase', 'Git'
    ];

    return (<div className={'min-vh-100 pt-'}>

        <Helmet>
            <title>App Develop - Service</title>
            <meta name="description" content="Yaroslav Lukyanchuk" />
        </Helmet>

        <div className="text-center mt-5">
            <div id={'whtat-todo__title-position'} className="p-5">
                <small className="text-secondary">
                    service
                </small>

                <h2 className={'display-1'}>
                    App Develop
                </h2>

            </div>
        </div>

        <div className="container-fluid text-dark text-start pt-5 mt-5">

            <div className="container d-flex">

                <div className="col-md-6 p-5">
                    <p className="mt-5">
                        Мобільні застосунки бувають різними за складністю, призначенням і функціоналом, тому назвати єдину ціну неможливо. Фіксовану вартість мають тільки готові застосунки, але якщо продукт розробляється під замовлення, то і ціна розробки мобільного додатка розраховується індивідуально. Вартість залежить від багатьох чинників.
                    </p>

                    <p className="mt-5">
                        <h4>Type work</h4>
                        <ul>
                            <li>
                                Cross-platform App
                            </li>
                            <li>
                                Android App
                            </li>
                            <li>
                                iOS App
                            </li>
                            <li>
                                API integration
                            </li>
                            <li>
                                Fix bug's
                            </li>
                            <li>
                                Support
                            </li>
                            <li>
                                Consultation
                            </li>
                        </ul>
                    </p>

                    <p className="mt-5">
                        <h4>Stack Technologies</h4>
                        <div className="d-flex flex-wrap align-items-center justify-content-between">
                            {
                                stack.map(value =>  <div className="item p-2">
                                    <small className="text-secondary border rounded-4 p-5 pt-1 pb-1">
                                        {value}
                                    </small>
                                </div>)
                            }

                        </div>
                    </p>


                    <p className="mt-5">
                        <h4>Whats include</h4>
                        Доступність 24/7 під час розробки проекту. Ви отримаєте код проекту. Ви матимете 5 правок для внесення в проект під час його розробки у будь який час.
                        За вашим запитом ви отримаєте проміжний результат (програму) проекту.
                    </p>

                    <p className="mt-5">
                        <h4>Options</h4>
                        <Link to={'/s/web-dev'} className={'nav-link'}>Web develop - API & Website  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                                                                                                                   className="bi bi-arrow-up-right-square-fill m-1" viewBox="0 0 16 16">
                            <path
                                d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM5.904 10.803 10 6.707v2.768a.5.5 0 0 0 1 0V5.5a.5.5 0 0 0-.5-.5H6.525a.5.5 0 1 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 .707.707"/>
                        </svg></Link>

                        <Link to={'/cooperation'} className={'nav-link'}>
                            Q&A Testing
                        </Link>

                        <Link to={'/cooperation'} className={'nav-link'}>
                            Publish
                        </Link>

                        <Link to={'/cooperation'} className={'nav-link'}>
                            Warranty support 24/7*
                        </Link>
                        <small className="text-secondary">
                            <i>*  from 6 to 12 month</i>
                        </small>
                    </p>

                    <p className="mt-5">
                        <h4>Price</h4>
                        <small className="text-secondary">
                            from $1,500.00
                        </small>
                    </p>

                    <div className="mt-5">
                        <Link to={'/cooperation'} className={'text-decoration-none text-dark display-4'}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor"
                                 className="bi bi-arrow-right" viewBox="0 0 16 16">
                                <path fill-rule="evenodd"
                                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                            </svg> <b>cooperation</b>
                        </Link>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="sticky-top">
                        <img
                            // src={'https://apps.lukyanchuk.com/image/iphoneNEW.png'}
                            src={'https://i.pinimg.com/originals/f3/61/53/f3615368cf0f682093efd99ca9523393.png'}
                            alt="iphone" className={'img-fluid mt-5'}/>
                    </div>
                </div>
            </div>

            <div className="example-service-project-work mt-5">

                <div className="container">
                    <h2 className={'display-4'}>Example project work</h2>
                </div>

                {/*TODO: add type show portfolio by category/service + limit*/}
                <div className="d-flex flex-wrap align-items-center mt-5">

                    <PortfolioApi optionService={'24'} />

                </div>
            </div>

        </div>

        {/*<div className="text-end p-5">*/}
        {/*    <Link to={'/cooperation'} className={'text-decoration-none text-dark display-4'}>*/}
        {/*        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor"*/}
        {/*             className="bi bi-arrow-right" viewBox="0 0 16 16">*/}
        {/*            <path fill-rule="evenodd"*/}
        {/*                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>*/}
        {/*        </svg> <b>get contact</b>*/}
        {/*    </Link>*/}
        {/*</div>*/}

    </div>);
}

export default AppServicesPage;
